import React from 'react';

const ContentRenderer = ({ content }) => {
  if (!content) {
    return (
      <div className="p-8 text-center text-gray-400">
        <p className="text-sm">Sadržaj još nije dodat.</p>
      </div>
    );
  }

  // Parse simple markdown-like formatting
  const renderLine = (line, index) => {
    if (line?.startsWith('# ')) {
      return (
        <h1 key={index} className="text-2xl font-bold text-gray-900 mt-6 mb-3 first:mt-0">
          {line?.slice(2)}
        </h1>
      );
    }
    if (line?.startsWith('## ')) {
      return (
        <h2 key={index} className="text-lg font-semibold text-gray-800 mt-6 mb-2 border-b border-gray-100 pb-1">
          {line?.slice(3)}
        </h2>
      );
    }
    if (line?.startsWith('### ')) {
      return (
        <h3 key={index} className="text-base font-semibold text-gray-700 mt-4 mb-1.5">
          {line?.slice(4)}
        </h3>
      );
    }
    if (line?.startsWith('- ') || line?.startsWith('* ')) {
      return (
        <li key={index} className="text-gray-700 text-sm leading-relaxed ml-4 list-disc">
          {renderInline(line?.slice(2))}
        </li>
      );
    }
    if (line?.trim() === '') {
      return <div key={index} className="h-2" />;
    }
    return (
      <p key={index} className="text-gray-700 text-sm leading-relaxed">
        {renderInline(line)}
      </p>
    );
  };

  const renderInline = (text) => {
    // Bold: **text**
    const parts = text?.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
    return parts?.map((part, i) => {
      if (part?.startsWith('**') && part?.endsWith('**')) {
        return <strong key={i} className="font-semibold text-gray-900">{part?.slice(2, -2)}</strong>;
      }
      if (part?.startsWith('*') && part?.endsWith('*')) {
        return <em key={i}>{part?.slice(1, -1)}</em>;
      }
      return part;
    });
  };

  const lines = content?.split('\n');

  return (
    <div className="px-8 py-8 space-y-1.5">
      {lines?.map((line, index) => renderLine(line, index))}
    </div>
  );
};

export default ContentRenderer;
